import {
  A2uiSurface,
  type ReactComponentImplementation,
} from '@a2ui/react/v0_9';
import {
  type A2uiMessage,
  type Catalog,
  MessageProcessor,
  type Subscription,
  type SurfaceModel,
} from '@a2ui/web_core/v0_9';
import { cn } from '@risksmart-app/atomic-ui';
import { useEffect, useState } from 'react';

export interface A2uiRendererProps {
  messages: A2uiMessage[];
  catalog: Catalog<ReactComponentImplementation>;
}

export const A2uiRenderer = ({ messages, catalog }: A2uiRendererProps) => {
  const [surfaces, setSurfaces] = useState<
    SurfaceModel<ReactComponentImplementation>[]
  >([]);

  useEffect(() => {
    const processor = new MessageProcessor([catalog]);
    const subscriptions: Subscription[] = [];
    const sync = () =>
      setSurfaces(Array.from(processor.model.surfacesMap.values()));

    subscriptions.push(processor.onSurfaceCreated(sync));
    subscriptions.push(processor.onSurfaceDeleted(sync));

    processor.processMessages(messages);

    return () => {
      subscriptions.forEach((subscription) => subscription.unsubscribe());
      processor.model.dispose();
      setSurfaces([]);
    };
  }, [messages, catalog]);

  return (
    <div className={cn('flex flex-col gap-2')}>
      {surfaces.map((surface) => (
        <A2uiSurface key={surface.id} surface={surface} />
      ))}
    </div>
  );
};
